import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

class HttpClient {
  private axios: AxiosInstance;

  constructor({ baseUrl }: { baseUrl: string }) {
    this.axios = axios.create({ baseURL: baseUrl });

    this.axios.interceptors.request.use(config => {
      config.withCredentials = true;
      return config;
    });
  }

  public get(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.get(url, options);
  }

  public post(url: string, body: any, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.post(url, body, options);
  }

  public delete(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.axios.delete(url, options);
  }
}

export default HttpClient;
